<template>
  <BootstrapModal class="EditProductGroup" v-on="$listeners">
    <div v-if="!configure">
      <FormInput class="form-element mb-2" v-model="$v.title.$model" id="supplier" label="Order title" :vuelidate="$v"
        fieldName="title" />
        <FormRichText v-model="$v.description.$model" id="supplier" label="Order description"
        :vuelidate="$v" fieldName="description" />
    </div>
    <div v-else>
      <div v-for="(item, index) in fields" 
        :key="index" :set="v => $v.fields.$each[index]"
        class="form-element mb-2"
        :class="{'text-danger': $v.fields.$each[index].$error}">
        <label class="control-label">
          <span class="label">
            {{ item.label  }}

            <span v-if="$v.fields.$each[index].value.$params.required" class="asterisk">
              *
            </span>
          </span>
        </label>
        <input class="form-control" :class="{'border-danger': $v.fields.$each[index].$error}" v-model="item.value" />
        <HandleVuelidateError v-if="$v.fields.$each[index].$error" :ins="$v.fields.$each[index].value"/>
      </div>
    </div>
    <template #title>
      Create supplier order
    </template>
    <template #slot-options>
      <div v-if="!configure">
        <button
          type="button"
          class="btn btn-primary"
          id="submit-button"
          @click="() => configure = true"
        >
        Configure Product
        </button>
      </div>
      <div v-else>
        <button
          type="button"
          class="btn btn-secondary"
          id="submit-button"
          @click="() => configure = false"
        >
          Terug
        </button>

        <button
          type="button"
          class="btn btn-primary"
          id="submit-button"
          style="margin-left: 7px"
          @click="saveProductGroup"
        >
        Opslaan
        </button>
      </div>
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"
import FormRichText from "src/components/Inputs/FormRichText"
import HandleVuelidateError from "/src/components/Inputs/HandleVuelidateError.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: ["order", "sku","callback"],
  components: {
    BootstrapModal,
    FormInput,
    FormRichText,
    HandleVuelidateError
  },
  validations: {
    title: {
      required,
    },
    description: {
      required,
    },
    fields: {
      $each: {
        value: { required }
      }
    }
  },
  data() {
    return {
      title: this.order ? this.order.title : "",
      description: this.order ? this.order.description : "",
      fields: this.order ? this.order.setting : [],
      configure: false
    }
  },
  created() {
    if (!this.order) {
      this.getProductSettingFields()
    }
  },
  methods: {
    saveProductGroup() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        title: this.$v.title.$model,
        description: this.$v.description.$model,
        setting: this.fields
      }

      this.$handlePromise(async () => {
        if (!this.order) {
          payload.sku = this.sku
          await this.axios.post(`/api/supplier_orders`, payload)
        } else {
          await this.axios.put(`/api/supplier_orders/${this.order.uid}`, payload)
        }
        this.$success("Supplier order succesvol opgeslagen!")
        this.callback && this.callback()
        this.$emit("close")
      })
    },
    getProductSettingFields() {
      this.$handlePromise(async () => {
        const fields = (await this.axios.get(`/api/products/${this.sku}/fields`)).data
        this.fields = fields
      })
    }
  },
}

</script>

<style scoped>
.EditProductGroup {
  flex-basis: 500px;
}
.control-label {
  position: relative;
  font-size: 1.08em !important;
  font-weight: 450;
  margin-bottom: 2px;
  color: #000000;
}
.asterisk {
  display: block;
  position: absolute;
  left: 100%;
  top: 0;
  margin-top: -2px;
  margin-left: 4px;
}
</style>
